import gsap from "gsap";
import { redirect, openWindow, getLinkFeatures } from "../lib/utilities";
const duration = 1.75;
const durationMs = duration * 1000;

function clickTransitionOutHandler(event) {
   event.preventDefault();

   const currentTarget = event.currentTarget;
   const url = currentTarget.href || null;

   if (url) {
      const transition = document.createElement("div");
      transition.className = "page-transition";
      document.body.appendChild(transition);

      gsap.to(
         transition,
         {
            transform: "scaleX(1)",
            duration: duration,
            ease: "expo.inOut",
         }
      )

      setTimeout(() => {
         if (typeof currentTarget.target === "string" && currentTarget.target === "_blank") {
            openWindow(url, currentTarget.target, getLinkFeatures(currentTarget));
         } else {
            redirect(url);
         }
      }, durationMs);
   }
}

window.addEventListener("DOMContentLoaded", () => {
   const transition = document.querySelector(".page-transition");
   if (transition) {
      transition.style.transform = "scaleX(0)";
   }
   Array.from(document.querySelectorAll(".page-transition-out")).forEach(element => element.addEventListener("click", clickTransitionOutHandler));
});
